import { useState } from 'react'

export const useChartTooltipConfig = (selector: string, chartContainer: HTMLDivElement | null): [boolean, () => void] => {
  const [isTooltipWider, setIsTooltipWider] = useState<boolean>(false)

  const onMouseMoveOrEnter = (): void => {
    if (!chartContainer) return

    const chartContainerWidth = chartContainer.getBoundingClientRect().width
    const tooltipElement = chartContainer.querySelector(selector)
    const tooltipElementWidth = tooltipElement?.getBoundingClientRect?.()?.width ?? 0

    const isWider = tooltipElementWidth >= chartContainerWidth - 1

    if (isWider === isTooltipWider) return
    setIsTooltipWider(isWider)
  }

  return [isTooltipWider, onMouseMoveOrEnter]
}
